export default "/assets/images/the-critter-cuddler-crop.png?cea55bd526046f9ad75262071a2f9abc";